import React from "react";
import { Path, Svg } from "react-native-svg";

const Snow = () => (
  <Svg width="118" height="118" viewBox="0 0 118 118" fill="none">
    <Path
      d="M54.2651 117.33V88.7308L32.4124 110.584L26.1059 104.424L54.2651 76.2645V63.0649H41.0655L13.493 90.6374L7.0398 84.6243L28.5992 63.0649H0V54.2651H28.5992L6.59981 32.2657L12.9063 25.9593L41.0655 54.2651H54.2651V40.9188L26.6926 13.3463L32.8524 6.89314L54.2651 28.4525V0H63.0649V28.4525L85.0642 6.45315L91.2241 12.7596L63.0649 40.9188V54.2651H76.4112L104.13 26.5459L110.437 32.7057L88.8775 54.2651H117.33V63.0649H88.8775L110.584 84.9176L104.57 91.2241L76.4112 63.0649H63.0649V76.2645L91.2241 104.57L85.2109 110.877L63.0649 88.7308V117.33H54.2651Z"
      fill="#000"
    />
  </Svg>
);

export default Snow;
